<template>
  <div class="cc-page">
    <Page
      class="page"
      show-total
      :total="total"
      show-sizer
      :placement="placement"
      :page-size-opts="pageSizeOpts"
      @on-change="onChange"
      @on-page-size-change="onPageSizeChange"
    />
  </div>
</template>
<script>
export default {
  name: "Pages",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    placement: {
      type: String,
      default: "bottom",
    },
    pageSizeOpts: {
      type: Array,
      default: () => [10, 20, 30, 40],
    },
  },
  methods: {
    onChange(current) {
      this.$emit("onChange", current);
    },
    onPageSizeChange(size) {
      this.$emit("onPageSizeChange", size);
    },
  },
};
</script>
<style lang="less" scoped>
.cc-page {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>
